document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-menu]');
if (menuToggle && menu) {
  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    menu.toggleAttribute('data-open', !open);
  });
}

document.querySelectorAll('[data-sort-by]').forEach((select) => {
  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url.toString());
  });
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const json = root.querySelector('[data-product-json]');
  const select = root.querySelector('[data-variant-select]');
  const price = root.querySelector('[data-product-price]');
  const mobilePrice = root.querySelector('[data-mobile-product-price]');
  const add = root.querySelector('[data-add-button]');
  if (!json || !select) return;

  const variants = JSON.parse(json.textContent);
  const optionInputs = [...root.querySelectorAll('[data-option-input]')];
  optionInputs.forEach((input) => input.addEventListener('change', () => {
    const selected = [];
    root.querySelectorAll('.variant-fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('[data-option-input]:checked');
      if (checked) selected.push(checked.value);
      const label = fieldset.querySelector('[data-selected-option]');
      if (label && checked) label.textContent = checked.value;
    });
    const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
    if (!variant) return;
    select.value = String(variant.id);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    if (price) price.textContent = money.format(variant.price / 100);
    if (mobilePrice) mobilePrice.textContent = money.format(variant.price / 100);
    if (add) {
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }));
});

document.querySelectorAll('[data-scroll-to-product-form]').forEach((button) => {
  button.addEventListener('click', () => {
    document.querySelector('[data-product-form]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});
